// extracted by mini-css-extract-plugin
export default {"scroll":"VendorStoreManage_scroll__B+hdF","success":"VendorStoreManage_success__9gjpL","error":"VendorStoreManage_error__mXfG3","border":"VendorStoreManage_border__yUS+9"};